export default __webpack_public_path__ + "static/media/bass.1253a1e3.jpg";